import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { ServiceTemplateScheduleRow } from "../serviceTemplateSchedulesViewConfig";
import { formatScheduleRecurrence } from "../serviceTemplateScheduleRecurrence";

export const ServiceTemplateScheduleScheduleCell = memo(
    ({
        row,
    }: CellContext<ViewTableFeatures, ServiceTemplateScheduleRow, unknown>) => {
        const { rowType } = row.original;
        if (rowType === "group") {
            // Group rows don't represent a single schedule — leave blank.
            return <ViewTableCell />;
        }

        const label = formatScheduleRecurrence(row.original);

        return (
            <ViewTableCell>
                <span>{label}</span>
            </ViewTableCell>
        );
    },
);

ServiceTemplateScheduleScheduleCell.displayName =
    "ServiceTemplateScheduleScheduleCell";
